import { siteConfig } from "../config/site.js";

window.onetrack = () => {};
window.__offlineErrors = [];
function captureError(event) {
  window.__offlineErrors.push(
    event.message || event.target?.src || "resource error",
  );
}
function captureRejection(event) {
  window.__offlineErrors.push(String(event.reason));
}
function originalLinks() {
  if (!siteConfig.externalizeNavigation) return;
  for (const link of document.querySelectorAll("a[href]")) {
    const href = link.getAttribute("href");
    if (!href || href.startsWith("#") || /^(mailto:|tel:)/.test(href)) continue;
    const url = new URL(href, location.href);
    if (url.origin === location.origin)
      link.href =
        siteConfig.originalOrigin + url.pathname + url.search + url.hash;
  }
}
function followOriginalLink(event) {
  if (!siteConfig.externalizeNavigation) return;
  const link = event.target.closest?.("a[href]");
  if (!link || !link.href.startsWith(siteConfig.originalOrigin + "/")) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (link.target === "_blank" || event.ctrlKey || event.metaKey)
    window.open(link.href, "_blank", "noopener");
  else location.href = link.href;
}
const observer = new MutationObserver(originalLinks);
observer.observe(document.documentElement, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ["href"],
});
window.addEventListener("error", captureError, true);
window.addEventListener("unhandledrejection", captureRejection);
document.addEventListener("DOMContentLoaded", originalLinks);
document.addEventListener("click", followOriginalLink, true);
originalLinks();
if (import.meta.hot)
  import.meta.hot.dispose(() => {
    observer.disconnect();
    window.removeEventListener("error", captureError, true);
    window.removeEventListener("unhandledrejection", captureRejection);
    document.removeEventListener("DOMContentLoaded", originalLinks);
    document.removeEventListener("click", followOriginalLink, true);
  });
